import styles from './ccf-interaction-search-column-icon.module.scss';
import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfInteractionSearchColumnIconProps {}

/**
 * Component displays CcfInteractionSearchColumnIcon Icon
 * @param props -CcfInteractionSearchColumnIconProps
 * @returns CcfInteractionSearchColumnIcon svg icon
 * @example <CcfInteractionSearchColumnIcon/>
 */
export function CcfInteractionSearchColumnIcon(
  props: CcfInteractionSearchColumnIconProps
) {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.92654 1.83337H11.5816C12.1182 1.83337 12.5612 1.83336 12.922 1.86284C13.2967 1.89345 13.6412 1.95916 13.9647 2.12402C14.4665 2.37969 14.8744 2.78763 15.1301 3.2894C15.2949 3.61296 15.3607 3.95743 15.3913 4.33216C15.4208 4.69295 15.4207 5.13585 15.4207 5.67249V11.3276C15.4207 11.8642 15.4208 12.3071 15.3913 12.6679C15.3607 13.0427 15.2949 13.3871 15.1301 13.7107C14.8744 14.2124 14.4665 14.6204 13.9647 14.8761C13.6412 15.0409 13.2967 15.1066 12.922 15.1372C12.5612 15.1667 12.1183 15.1667 11.5816 15.1667H5.92652C5.38988 15.1667 4.94698 15.1667 4.58619 15.1372C4.21145 15.1066 3.86699 15.0409 3.54343 14.8761C3.04166 14.6204 2.63371 14.2124 2.37805 13.7107C2.21319 13.3871 2.14748 13.0427 2.11687 12.6679C2.08739 12.3071 2.08739 11.8642 2.0874 11.3276V5.67251C2.08739 5.13586 2.08739 4.69295 2.11687 4.33216C2.14748 3.95743 2.21319 3.61296 2.37805 3.2894C2.63371 2.78763 3.04166 2.37969 3.54343 2.12402C3.86699 1.95916 4.21145 1.89345 4.58619 1.86284C4.94698 1.83336 5.38989 1.83337 5.92654 1.83337ZM7.42074 13.8334H10.0874V3.16671H7.42074V13.8334ZM6.0874 3.16671V13.8334H5.95407C5.38302 13.8334 4.99482 13.8329 4.69476 13.8083C4.40248 13.7845 4.25302 13.7412 4.14875 13.688C3.89787 13.5602 3.69389 13.3562 3.56606 13.1054C3.51293 13.0011 3.46965 12.8516 3.44577 12.5593C3.42125 12.2593 3.42074 11.8711 3.42074 11.3V5.70004C3.42074 5.12899 3.42125 4.74079 3.44577 4.44073C3.46965 4.14846 3.51293 3.99899 3.56606 3.89472C3.69389 3.64384 3.89787 3.43986 4.14875 3.31203C4.25302 3.25891 4.40248 3.21562 4.69476 3.19174C4.99482 3.16723 5.38302 3.16671 5.95407 3.16671H6.0874ZM11.4207 3.16671V13.8334H11.5541C12.1251 13.8334 12.5133 13.8329 12.8134 13.8083C13.1057 13.7845 13.2551 13.7412 13.3594 13.688C13.6103 13.5602 13.8142 13.3562 13.9421 13.1054C13.9952 13.0011 14.0385 12.8516 14.0624 12.5593C14.0869 12.2593 14.0874 11.8711 14.0874 11.3V5.70004C14.0874 5.12899 14.0869 4.74079 14.0624 4.44073C14.0385 4.14846 13.9952 3.99899 13.9421 3.89472C13.8142 3.64384 13.6103 3.43986 13.3594 3.31203C13.2551 3.25891 13.1057 3.21562 12.8134 3.19174C12.5133 3.16723 12.1251 3.16671 11.5541 3.16671H11.4207Z"
          fill="#003D7A"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfInteractionSearchColumnIcon;
